import { Routes, Route } from 'react-router-dom';

import {
  GenericQrStartPage,
  StartPage,
  DirectoryPage,
  BillingAddressPage,
  YourBillPage,
  TippingPage,
  PaymentPage,
  InvoicesPage,
  CheckoutSuccessPage,
  ThankYouPage,
  NotFoundPage,
} from './pages';

const AppRouter = () => (
  <Routes>
    {/* TODO: Handle request to root url better! */}
    <Route index element={<>Missing Url Params</>} />
    <Route path="/hotel/:uniqueId/property/:propertyId/">
      <Route path="start/" element={<GenericQrStartPage />} />
      <Route path=":selectedItemId/">
        <Route path="start/" element={<StartPage />} />
        <Route path="directory/" element={<DirectoryPage />} />
        <Route path="your-bill/" element={<YourBillPage />} />
        <Route path="tipping/" element={<TippingPage />} />
        <Route path="billing-address/" element={<BillingAddressPage />} />
        <Route path="payment/" element={<PaymentPage />} />
        <Route path="invoices/" element={<InvoicesPage />} />
        <Route path="checkout-success/" element={<CheckoutSuccessPage />} />
        <Route path="thank-you/" element={<ThankYouPage />} />
      </Route>
    </Route>
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default AppRouter;
